export const isWeChat = () => {
	var ua = window.navigator.userAgent.toLowerCase();
	// eslint-disable-next-line eqeqeq
	return ua.match(/MicroMessenger/i) == 'micromessenger';
};

export const getDeviceInfo = () => {
	// 获取设备用户代理字符串
	const userAgent = navigator.userAgent;
	const devcieInfo = {
		model: '',
		version: '',
	};
	if (userAgent.indexOf('iPhone') > -1) {
		// 判断用户代理字符串中是否包含'iPhone'，若包含则表示是iPhone手机
		// 解析出iPhone的型号和版本信息
		const regex = /iPhone\s(OS\s)?(\d[\d_]+)+/g;
		const matches = regex.exec(userAgent);
		if (matches) {
			const model = 'iPhone';
			const version = matches[2].replace(/_/g, '.');
			// console.log('Device model: ' + model)
			// console.log('iOS version: ' + version)
			devcieInfo.model = model;
			devcieInfo.version = version;
		}
	} else if (userAgent.indexOf('Android') > -1) {
		// 判断用户代理字符串中是否包含'Android'，若包含则表示是Android手机
		// 解析出Android的型号和版本信息
		const regex = /Android\s(\d[\d.]+)+;/g;
		const matches = regex.exec(userAgent);
		if (matches) {
			const version = matches[1];
			// 判断设备型号
			const model = 'android';
			// if (userAgent.indexOf('Mi') > -1) {
			//   model = 'Xiaomi'
			// } else if (userAgent.indexOf('HUAWEI') > -1) {
			//   model = 'HUAWEI'
			// } else if (userAgent.indexOf('OPPO') > -1) {
			//   model = 'OPPO'
			// } else if (userAgent.indexOf('vivo') > -1) {
			//   model = 'vivo'
			// } else {
			//   model = 'Other android'
			// }
			// console.log('Device model: ' + model)
			// console.log('Android version: ' + version)
			devcieInfo.model = model;
			devcieInfo.version = version;
		}
	}
	return devcieInfo;
};

export const getQueryParams = name => {
	var url_string = location.href;
	var params = url_string.split('?')[1]; // 获取?号后面的参数 name=mick&age=20
	if (!params) return null; // 如果无参，返回null
	var vars = params.split('&'); // 将参数分割成数组 ['name=mick', 'age=20']
	var query_string = {};
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('='); // 将参数的key和值进行分割成 ['name', 'mick']
		var key = decodeURIComponent(pair[0]); // 参数key
		var value = decodeURIComponent(pair[1]); // 参数值
		query_string[key] = value;
	}
	return query_string;
};

// 新增或者替换某个query参数
export const historyReplaceTab = ({ name, value }) => {
	const stateObj = history.state || {};
	const queryObj = {};
	let url = location.origin + location.pathname;
	if (location.hash) {
		url += location.hash.split('?')[0];
	}
	const arr = location.href.split('?');
	// 获取url自带的参数
	if (arr[1]) {
		const aKeyValue = arr[1].split('&');
		aKeyValue.forEach(ele => {
			const oKeyValue = ele.split('=');
			if (oKeyValue[1] && oKeyValue[1] !== 'undefined') {
				stateObj[oKeyValue[0]] = oKeyValue[1];
				queryObj[oKeyValue[0]] = oKeyValue[1];
			}
		});
	}
	queryObj[name] = value;
	let query = '';
	Object.keys(queryObj).forEach(key => {
		if (queryObj[key]) {
			// 抛弃空值
			if (query) {
				query += `&${key}=${queryObj[key]}`;
			} else {
				query += `?${key}=${queryObj[key]}`;
			}
		}
	});

	history.replaceState(stateObj, history.title, url + query);
};

export const createId = () => {
	return new Date().getTime() + Math.random().toString(36).substring(2);
};

// 获取URL是字符串的param值
export const getParamValue = (url, paramName) => {
	const match = url.match(new RegExp(`${paramName}=([^&]+)`));
	return match ? match[1] : null;
}

// 获取URL是字符串的param值，并返回一个对象
export const getUrlParamsObject = (url) => {
	const queryString = url.split('?')[1];
	if (!queryString) {
		return {};
	}
	const paramsArray = queryString.split('&');
	const paramsObject = {};
	for (const param of paramsArray) {
		const [key, value] = param.split('=');
		paramsObject[key] = decodeURIComponent(value);
	}
	return paramsObject;
}

export const getRandomFromArray = (arr, count) => {
	const result = [];
	const length = arr.length;
	// 如果需要获取的数量大于数组长度，则直接返回数组本身
	if (count >= length) {
		return arr;
	}
	// 循环获取指定数量的随机值
	while (result.length < count) {
		// 生成一个随机索引
		const randomIndex = Math.floor(Math.random() * length);
		// 检查该值是否已经在结果数组中，如果不在，则添加到结果数组中
		if (!result.includes(arr[randomIndex])) {
			result.push(arr[randomIndex]);
		}
	}
	return result;
}

export const updateMultipleParams = (url, newParams) => {
	let updatedUrl = url;
	for (const [paramName, paramValue] of Object.entries(newParams)) {
		const regex = new RegExp(`([?&])${paramName}=.*?(&|$)`, 'i');
		if (updatedUrl.match(regex)) {
		updatedUrl = updatedUrl.replace(regex, `$1${paramName}=${paramValue}$2`);
		} else {
			const separator = updatedUrl.includes('?') ? '&' : '?';
			updatedUrl = `${updatedUrl}${separator}${paramName}=${paramValue}`;
		}
	}
	return updatedUrl;
  }

  /**
 * 移除 URL 中的指定参数
 * @param {string} [url=window.location.href] - 待处理的 URL，默认当前页面 URL
 * @param {string|string[]} paramsToRemove - 需要移除的参数（单个参数名或参数名数组）
 * @returns {string} 处理后的 URL
 */
export const removeUrlParams = (url = window.location.href, paramsToRemove) => {
  // 解析 URL（处理可能的相对路径或完整 URL）
  const urlObj = new URL(url, window.location.origin);
  const searchParams = urlObj.searchParams;

  // 统一转为数组处理（支持单个参数或多个参数）
  const params = Array.isArray(paramsToRemove) ? paramsToRemove : [paramsToRemove];

  // 移除指定参数
  params.forEach(param => {
    if (searchParams.has(param)) {
      searchParams.delete(param);
    }
  });

  // 重新构建查询字符串（处理空参数的情况，避免出现 "?"）
  const newSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';

  // 拼接新 URL（协议 + 主机 + 路径 + 新查询参数 + 哈希）
  return `${urlObj.origin}${urlObj.pathname}${newSearch}${urlObj.hash}`;
}

export const extractParamLegacy = (url, paramName) => {
  // 步骤1：去除 URL 中的哈希部分（# 及后面内容）
  const urlWithoutHash = url.split('#')[0]
  // 步骤2：提取查询参数部分（? 后面的内容）
  const queryIndex = urlWithoutHash.indexOf('?')
  if (queryIndex === -1) return null // 无查询参数，返回 null
  const queryString = urlWithoutHash.slice(queryIndex + 1)
  // 步骤3：分割所有参数，遍历查找
  const params = queryString.split('&')
  for (const param of params) {
    const [key, value] = param.split('=')
    if (key === paramName && value) {
      return value
    }
  }
  return null // 未找到参数
}

/**
 * 提取链接中 .whlcslt.cn 格式的域名
 * @param {string} url - 目标链接（如 "https://delivery.whlcslt.cn/LCWXJoinAssistant/..."）
 * @returns {string|null} 带前缀点的目标域名（.whlcslt.cn），URL 无效则返回 null
 */
export const extractTargetDomain = (url) => {
  try {
    // 1. 解析 URL，获取完整域名（含子域名，如 "delivery.whlcslt.cn"）
    const urlObj = new URL(url);
    const fullDomain = urlObj.hostname; // 核心：获取 hostname（自动剔除端口号）

    // 2. 拆分域名层级，提取主域名（whlcslt.cn）
    const domainParts = fullDomain.split('.'); // 拆分结果：['delivery', 'whlcslt', 'cn']
    const mainDomain = domainParts.slice(-2).join('.'); // 取后两位拼接：'whlcslt.cn'

    // 3. 生成目标格式（带前缀点 .whlcslt.cn）
    const targetDomain = `.${mainDomain}`;

    return targetDomain;
  } catch (error) {
    console.error('URL 格式无效，提取失败：', error);
    return null;
  }
}

// 手机号校验
export const checkPhone = (phone) => {
	const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
	return reg.test(phone)
}
